import script from "./InlineSvg.vue?vue&type=script&lang=ts"
export * from "./InlineSvg.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__